var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestorOfferBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 20,
    viewBox: "0 0 81 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18V2C0 0.895431 0.895429 0 2 0H79.0793C79.8884 0 80.3625 0.910686 79.8986 1.57346L74.4014 9.42654C74.1604 9.77086 74.1604 10.2291 74.4014 10.5735L79.8986 18.4265C80.3625 19.0893 79.8884 20 79.0793 20H2C0.895431 20 0 19.1046 0 18Z",
    fill: "url(#paint0_linear_904_17116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_904_17116",
    x1: 46.575,
    y1: 11.875,
    x2: 36.8998,
    y2: -16.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71EDB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorOfferBg);
export default __webpack_public_path__ + "static/media/investorOfferBg.2777bc8acd7172139d340844f0607e72.svg";
export { ForwardRef as ReactComponent };